module.exports = __webpack_public_path__ + "img/floor_f19_01.0ac15aab.png";